import React, { Component } from 'react';


class Footer extends Component {

    render() {
        return (
            <tr>
                <td style={{ position: 'relative', height: '60px' }}>
                    <img src="/assets/report-icons/footer-img.png" alt="" style={{ position: 'absolute', top: 0, width: '100%', left: 0, zIndex: -1 }} />
                    {/* <p style={{ fontSize: '14px', marginLeft: '15px', fontWeight: 500 }}>confidential - for internal use only</p> */}
                </td>
            </tr>
        )
    }
}

export default Footer;